module.exports = __webpack_public_path__ + "img/mike.855eed77.gif";